import React from 'react';

const PRESET_AVATARS = {
  teal:    { bg: '#1B7A8A', shadow: '#0e4f5a' },
  purple:  { bg: '#4A1D5E', shadow: '#2e1240' },
  navy:    { bg: '#13335e', shadow: '#0a1f3d' },
  slate:   { bg: '#4B5563', shadow: '#2d3748' },
  coral:   { bg: '#E05C5C', shadow: '#b83c3c' },
  gold:    { bg: '#C9952A', shadow: '#9a6f1a' },
  moss:    { bg: '#4A7C59', shadow: '#2e5038' },
  indigo:  { bg: '#4F46E5', shadow: '#3730a3' },
  unveiled: { bg: '#FFFFFF', shadow: '#1A1A1A' },
};

function SilhouetteAvatar({ color, size }) {
  const { bg, shadow } = PRESET_AVATARS[color] || PRESET_AVATARS.teal;
  const isUnveiled = color === 'unveiled';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      style={{
        borderRadius: '50%',
        display: 'block',
        flexShrink: 0,
        border: isUnveiled ? '2px solid #e5e7eb' : 'none'
      }}
    >
      <circle cx="50" cy="50" r="50" fill={bg} />
      <circle cx="50" cy="38" r="18" fill={shadow} />
      <ellipse cx="50" cy="82" rx="28" ry="20" fill={shadow} />
    </svg>
  );
}

export default function Avatar({ username, size = 40, avatarId }) {
  if (avatarId && PRESET_AVATARS[avatarId]) {
    return <SilhouetteAvatar color={avatarId} size={size} />;
  }

  // Fallback to DiceBear
  const avatarUrl = `https://api.dicebear.com/7.x/shapes/svg?seed=${encodeURIComponent(username || 'default')}&backgroundColor=1B7A8A,4A1D5E&scale=80`;
  return (
    <img
      src={avatarUrl}
      alt={`${username}'s avatar`}
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        backgroundColor: '#130d20',
        flexShrink: 0
      }}
    />
  );
}

export { PRESET_AVATARS };